import { EOrderType } from '@webtrader/core/api/order';
import request from '@webtrader/core/request';

import { ESignalAction, ESignalDirection, ESignalOrderStatus } from './index';

export interface ISignalDetails {
  stop: number;
  action: ESignalAction;
  phrase: string[];
  status: ESignalOrderStatus;
  created: number;
  duration: string;
  piaChart: string;
  orderType: EOrderType;
  direction: ESignalDirection;
  confidence: number;
  entryTarget: number;
  modifiedDate: number;
  publishedDate: number;
  buyOrSellPhrase: string[];
  target1: number;
  target2: number;
  support1: number;
  support2: number;
  support3: number;
  resistance1: number;
  resistance2: number;
  resistance3: number;
}

export interface ISignalDetailsParams {
  id: string;
  symbol: string;
}

const signalsDetail = (params: ISignalDetailsParams) => {
  return request.get<ISignalDetails>('/api/plugin/v1/signals/detail', {
    params
  });
};

export default signalsDetail;
